/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { getLandingContainer } from "../../utils/getLandingContainer"
import { ISectionEditProps } from "./SectionAddButton"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILayoutCellProps extends ISectionEditProps {
   
}
const LayoutCell = (props: ILayoutCellProps): JSX.Element => {
    const sizes         = useLandingSize()
    const width         = useSyncState<number>(sizes.width)    
    const {toolPanel}   = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings) 
    useEffect(() => {
        const landing = getLandingContainer().getBoundingClientRect()
        width.set( landing.width )
    }, [ sizes ])
    return <div className='landing-layout-cell-container ' style={{ width: width.get(), visibility: "hidden", marginLeft: !!toolPanel ? 25 : 0 }}>
        
        <div className="position-absolute top left w-100 h-100">
            <div className="large-container v-line"></div>
        </div>
        
        <div className="position-absolute top left w-100 h-100">
            <div className="container v-line"></div>
        </div>
        <div className="position-absolute top left w-100 h-100">
            <div className="container v-line"></div>
        </div>
        <div className="position-absolute top left w-100 h-100">
            <div className="short-container v-line"></div>
        </div>        
        <div className="position-absolute top left w-100 h-100">
            <div className="small-container v-line"></div>
        </div>
        <div className="position-absolute top left w-100 h-100">
            <div className="micro-container v-line"></div>
        </div>
    </div>
}
export default LayoutCell